import { utc } from '@date-fns/utc'
import { Card, CardContent, Skeleton, Box, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useSearch } from '@tanstack/react-router'
import { addMonths, startOfMonth } from 'date-fns'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { I18NAwareLocalizationProvider } from '@/components/I18NAwareLocalizationProvider'
import { SingleLineTextInputSkeleton } from '@/components/SingleLineTextInputSkeleton'

const today = new Date()
export const StatisticsPendingComponent: React.FC = () => {
    const { t } = useTranslation()

    const { from, to } = useSearch({
        from: '/__base-layout/statistics',
    })

    const parsedDateFrom = React.useMemo(
        () =>
            from === undefined ? startOfMonth(today, { in: utc })
            : typeof from === 'string' ? new Date(from)
            : from,
        [from]
    )
    const parsedDateTo = React.useMemo(
        () =>
            to === undefined ? startOfMonth(addMonths(today, 1))
            : typeof to === 'string' ? new Date(to)
            : to,
        [to]
    )

    return (
        <Card>
            <title>{t('common.statistics')}</title>

            <CardContent>
                <Box
                    sx={{
                        my: 2,
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <I18NAwareLocalizationProvider>
                        <DatePicker
                            label={t('common.from')}
                            value={parsedDateFrom}
                            disabled={true}
                            sx={{ flex: 1, minWidth: 200 }}
                        />

                        <DatePicker
                            label={t('common.to')}
                            value={parsedDateTo}
                            disabled={true}
                            sx={{ flex: 1, minWidth: 200 }}
                        />
                    </I18NAwareLocalizationProvider>

                    <SingleLineTextInputSkeleton
                        style={{ flex: 1, minWidth: 200 }}
                        margin={false}
                    />
                </Box>

                <Typography variant={'h6'} sx={{ mt: 3 }}>
                    {t('statistics.hoursPerProject')}
                </Typography>

                <Box sx={{ height: 300, mt: 1 }}>
                    <Skeleton
                        width={'100%'}
                        height={300}
                        style={{ transform: 'unset' }}
                    />
                </Box>

                <Typography variant={'h6'} sx={{ mt: 3 }}>
                    {t('statistics.hoursInTimespan')}
                </Typography>

                <Box sx={{ height: 300, mt: 1 }}>
                    <Skeleton
                        width={'100%'}
                        height={300}
                        style={{ transform: 'unset' }}
                    />
                </Box>
            </CardContent>
        </Card>
    )
}
